module.exports = __webpack_public_path__ + "img/consult-phone.e96e05c7.png";